// The day of the date as yyyy-MM-dd in the local time: e.g. a date picked in Finland
// before 3 o'clock is not moved to the previous day (as with toISOString in UTC)
const getISODate = (date: Date | null | undefined): string | undefined => {
  if (date === null || date === undefined || Number.isNaN(date.getTime())) {
    return undefined;
  }

  const month = `${date.getMonth() + 1}`.padStart(2, '0');
  const day = `${date.getDate()}`.padStart(2, '0');
  return `${date.getFullYear()}-${month}-${day}`;
};

export default getISODate;
